module.exports = __webpack_public_path__ + "img/double-image-hero-toyota.bfa8de98.png";